// extracted by mini-css-extract-plugin
export default {"container":"Join_container__m7EJR","left":"Join_left__F4dmd","joinBtn":"Join_joinBtn__XC1G3","joinp":"Join_joinp__Qdwwp"};